'use strict';

// export this package's api
module.exports = require('./Animate');


//////////////////
// WEBPACK FOOTER
// ./~/rc-animate/lib/index.js
// module id = ./node_modules/rc-animate/lib/index.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons